import React from 'react';

export function NativeScrollArea({ children }) {
  return <div>{children}</div>;
}
